<template>
  <form-field-select
    :label="label"
    v-model="entity.timezone"
    :validation-errors="validationErrors.timezone"
    :size="size"
  >
    <option
      v-for="timezone in timezones"
      :key="timezone"
      :value="timezone"
    >{{ timezone }}</option>
  </form-field-select>
</template>

<script>
export default {
  name: "FormFieldTimezones",
  props: {
    label: {
      type: String,
      default: 'Timezone'
    },
    entity: {
      type: Object,
      required: true
    },
    validationErrors: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'is-small'
    }
  },
  data() {
    return {
      timezones: this.$store.getters.timezones,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
